var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.app)?[_c('ul',{staticClass:"nav nav-mobile-menu mobile-app-menu",on:{"click":_vm.toggleSidebar}},[_c('li',[_c('router-link',{staticClass:"dropdown-link",attrs:{"to":{
            name: 'IFIntro',
            params: { uid: 123234 },
          }}},[_c('md-icon',[_vm._v("chat_bubble")]),_c('p',[_vm._v("Information")])],1)],1),_c('li',[_c('router-link',{staticClass:"dropdown-link",attrs:{"to":{
            name: 'IFProfitAndLoss',
            params: { uid: 123234 },
          }}},[_c('md-icon',[_vm._v("analytics")]),_c('p',[_vm._v("Profit & Loss")])],1)],1),_c('li',[_c('router-link',{staticClass:"dropdown-link",attrs:{"to":{
            name: 'IFBalanceSheet',
            params: { uid: 123234 },
          }}},[_c('md-icon',[_vm._v("table_chart")]),_c('p',[_vm._v("Balance Sheet")])],1)],1),_c('li',[_c('router-link',{staticClass:"dropdown-link",attrs:{"to":{
            name: 'IFRatios',
            params: { uid: 123234 },
          }}},[_c('md-icon',[_vm._v("scatter_plot")]),_c('p',[_vm._v("Ratios")])],1)],1),_c('li',[_c('router-link',{staticClass:"dropdown-link",attrs:{"to":{
            name: 'IFSourcesUses',
            params: { uid: 123234 },
          }}},[_c('md-icon',[_vm._v("collections_bookmark")]),_c('p',[_vm._v("Sources Users")])],1)],1),_c('li',[_c('router-link',{staticClass:"dropdown-link",attrs:{"to":{
            name: 'IFValuationMultiples',
            params: { uid: 123234 },
          }}},[_c('md-icon',[_vm._v("query_stats")]),_c('p',[_vm._v("Valuation Multples")])],1)],1),_c('li',[_c('router-link',{staticClass:"dropdown-link",attrs:{"to":{
            name: 'IFAbout',
            params: { uid: 123234 },
          }}},[_c('md-icon',[_vm._v("help")]),_c('p',[_vm._v("About the Data")])],1)],1)])]:_vm._e(),(!_vm.app)?[_c('ul',{staticClass:"nav nav-mobile-menu"})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }